<template>
  <div class="yhc-es-form-from-to-select-section">
    <YhcEFSectionTitle>お預かり先・お届け先</YhcEFSectionTitle>
    <div class="d-flex justify-content-center flex-wrap delivery-input-contents">
      <YhcEFZipCodeInput
        title="お預かり先"
        :model-value="$yhcefs.$userInputData.zip_from"
        :from-or-to="'from'"
        :zip-code-master="
          YhcEstimateFormFrontServiceInstance.$userInputData.zip_from_yhc_master
        "
        @update:modelValue="
          async (updatedValue) => {
            await $yhcefs.$userInputData.updateZip(updatedValue, 'zip_from')
          }
        "
      />
      <YhcEFZipCodeInput
        title="お届け先"
        :model-value="$yhcefs.$userInputData.zip_to"
        :from-or-to="'to'"
        :zip-code-master="
          YhcEstimateFormFrontServiceInstance.$userInputData.zip_to_yhc_master
        "
        @update:modelValue="
          async (updatedValue) => {
            await $yhcefs.$userInputData.updateZip(updatedValue, 'zip_to')
          }
        "
      />
    </div>
    <!-- 24.03.22 不要のため除外
    <div class="text-center small p-2 mt-4 delivery-area-note-text">
      お預かり先、お届け先ともに一部のエリアのみ対応しております。対応エリアは <a href="#" @click.prevent="() => false" class="area-note-link">こちら</a> をご確認ください。
    </div>
    -->
    <!--    <div class="container">
      <pre>pref_from_to_info_master: {{ $yhcefs.$userInputData.pref_from_to_info_master }}</pre>
    </div>-->
  </div>
</template>
<script lang="ts">
import YhcEFZipCodeInput from './ZipCodeInput/YhcEFZipCodeInput.vue'
import { YhcEstimateFormFrontService } from '../YhcEstimateFormFrontService'
export default {
  name: 'ZipCodeInput',
  components: {
    YhcEFZipCodeInput,
  },
  inject: ['YhcEstimateFormFrontServiceInstance'],
  computed: {
    $yhcefs(): YhcEstimateFormFrontService {
      return this.YhcEstimateFormFrontServiceInstance
    },
  },
  mounted() {
    // [開発用] autoload なら... ここで zipMaster を読み込む
    if (this.$yhcefs.enableAutoSaveOfUserInputData) {
      this.$yhcefs.$userInputData.refreshMastersForSelectedDates()
    }
  },
}
</script>
